import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import YouWillConform from '../components/YouWillConform.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/puzzles',
    name: 'Puzzles',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Puzzles.vue'),
    children: [
      // one has to be the default
      {
        path: "",
        component: YouWillConform
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: "active"
})

export default router
